import React, { useState, useCallback } from 'react';
import { EditProfileContext } from './edit-profile-context-definition';

export const EditProfileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <EditProfileContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </EditProfileContext.Provider>
  );
};
